<div class="aems-bread-crumb m-b-16"><a routerLink="/master-data">Master Data</a><span> / Part Code Exclusion</span></div>
<div class="list-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24"><h3 class="inline m-r-4">Part Code Exclusion</h3></div>
    <form [formGroup]="filters" class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <mc-input class="search-bar" hiddenlabel placeholder="Search for a part number" fit="small" icon="magnifying-glass" formControlName="searchText" (keyup.enter)="search()"></mc-input>
    </form>
  </div>
  <div class="pure-g m-t-16" style="align-items: center; display: flex; justify-content: flex-end">
    <div class="pure-u-md-6-24 pure-u-lg-5-24 pure-u-xl-4-24 right">
      @if (canAdd) {
        <mc-button appearance="primary" fit="small" (click)="addNew()" (keydown.enter)="addNew()" (keydown.space)="$event.preventDefault(); addNew()">Add New</mc-button>
      }
    </div>
  </div>
  <div class="m-t-8 quick-filter-box part-exclusion-filter-bar">
    <div class="applied-filter-holder">
      @if (filters.controls.repairModeList.value.length) { <span>Mode: {{ filters.controls.repairModeList.value.join(', ') }}</span> }
      @if (filters.controls.partCodeDescriptionList.value.length) { <span class="m-l-8">Part Number: {{ filters.controls.partCodeDescriptionList.value.join(', ') }}</span> }
      @if (filters.controls.repairModeList.value.length || filters.controls.partCodeDescriptionList.value.length || filters.controls.searchText.value) {
        <mc-button class="clear-btn" appearance="primary" variant="plain" fit="small" (click)="clearFilters()" (keydown.enter)="clearFilters()" (keydown.space)="$event.preventDefault(); clearFilters()">Clear All</mc-button>
      }
    </div>
    <div class="utility-buttons">
      <div style="display: flex; align-items: right; gap: 1px">
        <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
          <mc-button
            class="utility-button-no-round"
            slot="trigger"
            appearance="neutral"
            variant="filled"
            icon="sliders-horizontal"
            hiddenlabel
            padding="default"
            fit="medium"
            (click)="filtersOpen = true"
            (keydown.enter)="filtersOpen = true"
            (keydown.space)="$event.preventDefault(); filtersOpen = true">
            Filters
          </mc-button>
          <span>Filters</span>
        </mc-tooltip>
        @if (authPolicies.canViewPartExclusion) {
          <mc-button
            class="utility-button download"
            variant="filled"
            appearance="neutral"
            fit="medium"
            [loading]="isDownload"
            icon="tray-arrow-down"
            hiddenlabel
            padding="default"
            (click)="onDownload()"
            (keydown.enter)="onDownload()"
            (keydown.space)="$event.preventDefault(); onDownload()">
            Download
          </mc-button>
        }
      </div>
    </div>
  </div>
  <div class="table-container m-t-12">
    @if (loading) {
      <div class="aems-card">Loading part exclusion rules...</div>
    } @else if (data.length) {
      <mc-table [data]="data" [columns]="columns" fit="small" nowrap="true" sortmanual sortdefaultdirection="ascending" tabularFigures="true" headersticky height="100%" (sortchange)="onSort($event)">
        @for (row of data; track row; let i = $index) {
          <div slot="{{ row.id }}_repairMode">
            <button type="button" class="mode-link" (click)="openDetail(row)">
              {{ row.repairMode }}
            </button>
          </div>
        }
      </mc-table>
    } @else {
      <div class="aems-card">No part exclusion rules found. To widen your search, change or remove filters.</div>
    }
  </div>
  @if (data.length) {
    <app-pagination [currentPage]="currentPage" [lastPage]="lastPage" [totalRecords]="totalRecords" [pageLimit]="pageLimit" [showCountOnly]="true" (pageChange)="pageChanged($event)" (pageSizeChange)="pageSizeChanged($event)"></app-pagination>
  }
</div>
<mc-modal heading="Filters" fit="small" dimension="large" [open]="filtersOpen" (closed)="filtersOpen = false">
  <form [formGroup]="filters" class="pure-g">
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <app-aems-multiline-tag-input
        label="Part Number"
        placeholder="Enter part number and press Enter"
        [regex]="partNumberRegex"
        [transformToUppercase]="true"
        formControlName="partCodeDescriptionList">
      </app-aems-multiline-tag-input>
    </div>
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select ngDefaultControl label="Mode" fit="medium" placeholder="Select modes" formControlName="repairModeList">
        @for (mode of modes; track mode) { <mc-option [value]="mode">{{ mode }}</mc-option> }
      </mc-multi-select>
    </div>
  </form>
  <mc-button slot="secondaryAction" appearance="neutral" variant="outlined" (click)="clearFilters()" (keydown.enter)="clearFilters()" (keydown.space)="$event.preventDefault(); clearFilters()">Clear filters</mc-button>
  <mc-button slot="primaryAction" appearance="primary" (click)="applyFilters()" (keydown.enter)="applyFilters()" (keydown.space)="$event.preventDefault(); applyFilters()">Apply filters</mc-button>
</mc-modal>
